import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="maintenance-page">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-8 text-center space-y-6 border border-slate-200">
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-800">System Under Maintenance</h1>
        <p className="text-slate-600 leading-relaxed">
          FY closing in progress. System will be available shortly.
        </p>
        <div className="border-t pt-4">
          <p className="text-xs text-slate-400">
            If you need urgent access, please contact your administrator.
          </p>
        </div>
      </div>
    </div>
  );
}
